<header class="header">
  <nav class="navbar navbar-expand-lg header-navbar">
    <a class="navbar-brand header-brand" routerLink="/">
      <img
        *ngIf="translate.currentLang === 'ar'"
        src="/assets/images/evento-logo.svg"
        width="60"
        height="40"
        alt="header logo"
        aria-label="header logo"
        class="image"
      />
      <img
        *ngIf="translate.currentLang === 'en'"
        src="/assets/images/evento-logo-en.svg"
        alt=""
        class="image"
      />
    </a>

    <button
      class="navbar-toggler header-togglerBtn"
      type="button"
      aria-label="toggle menu"
      (click)="isMenuCollapsed = !isMenuCollapsed"
    >
      <i class="fas fa-bars"></i>
    </button>

    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse">
      <ul class="navbar-nav mr-auto ml-auto header-menu">
        <ng-container *ngFor="let link of navItems">
          <li
            class="nav-item"
            *ngIf="
              link.authorized
                ? link.title == 'Admin'
                  ? helpers.isUserAdmin
                  : link.title == 'Dashboard'
                  ? helpers.isUserEventCreator || helpers.isUserEventUser
                  : false
                : true
            "
            (click)="isMenuCollapsed = !isMenuCollapsed"
            routerLinkActive="active"
          >
            <a
              class="nav-link"
              *ngIf="!link.external && !link.dashboard"
              [routerLink]="link.route"
            >
              {{ link.title | translate }}
            </a>
            <a
              class="nav-link"
              style="cursor: pointer"
              *ngIf="link.external && !link.dashboard"
              (click)="navigateToExternal($event)"
            >
              {{ link.title | translate }}
            </a>
            <a
              class="nav-link"
              style="cursor: pointer"
              *ngIf="!link.external && link.dashboard"
              (click)="navigateToDashboard($event)"
            >
              {{ link.title | translate }}
            </a>
          </li>
        </ng-container>
      </ul>

      <div class="header-additonLinks">
        <ng-container *ngIf="!helpers.getUserFromToken()">
          <button
            [routerLink]="['/auth/']"
            class="btn header-loginBtn ms-1 me-1"
          >
            {{ "login" | translate }}
          </button>
          <button
            [routerLink]="['/auth/signup-type']"
            class="btn header-loginBtn"
          >
            {{ "Create New Account" | translate }}
          </button>
        </ng-container>

        <div class="dropdown" *ngIf="helpers.getUserFromToken()" ngbDropdown>
          <button
            class="btn header-loginBtn"
            id="loginDropdown"
            ngbDropdownToggle
          >
            {{ user.firstName }}
          </button>
          <div class="dropdown-menu" ngbDropdownMenu>
            <ng-container>
              <a
                class="dropdown-item"
                ngbDropdownItem
                [routerLink]="['/tickets']"
                >{{ "my personal account" | translate }}
              </a>
              <a
                class="dropdown-item text-danger"
                ngbDropdownItem
                href="#"
                (click)="$event.preventDefault(); logout()"
              >
                {{ "logout" | translate }}
              </a>
            </ng-container>
          </div>
        </div>

        <button
          type="button"
          class="header-langBtn ms-1 me-1"
          (click)="onSwitchLanguages()"
        >
          <span>{{ "language" | translate }}</span>
          <i class="fas fa-globe mb-1"></i>
        </button>
      </div>
    </div>
  </nav>
</header>
